import ReportTemplates from './ReportTemplates';

export default ReportTemplates;
